export class InterventoPaziente {
    richiestaId: String | undefined;
    strutturaId: number | undefined;
    operatoreId: number | undefined;
    frequenza: String | undefined;
    tipoInterventoId: number | undefined;
    tipoOperatore: number | undefined;
    attivita: Attivita[] | undefined;
}


export interface Attivita {
    id: number;
    codice: string;
    descrizione: string;
  }
  